import {useEffect} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {useOnScreenObserver} from "../../atoms/chat_bot/feedback_popup/hooks/use_on_screen_observer";
import {MultileadModal} from "../../lead/multilead/components/multilead_modal/MultileadModal";
import {openMultilead} from "../../lead/multilead/state/multilead_slice";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {useAppDispatch} from "../../store/hooks";
import {gtmEventClickSimilarPropertiesCTA, gtmEventShowSimilarPropertiesCTA} from "../../tracking/google_tag_manager/gtm_event_similar_properties_cta";
import {PREMULTILEAD_TRIGGER} from "../constants/premultilead_trigger";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {IRecommendedProperty} from "../types/IRecommendedProperty";

import preMultiLeadMapImage from "../images/preMultiLeadMapImage.png";

interface IProps {
    property: IPropertyDetail;
    recommendedProperties: IRecommendedProperty[];
}

export const _PropertyDetailPreMultiLeadSection = (props: IProps) => {
    const {property, recommendedProperties} = props;
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const buttonText = InquiryButtonTypeName.SHOW_SIMILAR_OFFERS;
    const flatsPlural = pluralize(["mieszkanie zgodne", "mieszkania zgodne", "mieszkań zgodnych"]);
    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(PREMULTILEAD_TRIGGER);

    const openModal = () => {
        dispatch(
            openMultilead({
                mainPropertyId: property.id,
                mainOfferId: property.offer.id,
                mainVendorId: property.offer.vendor.id,
                sourceSection: ApplicationSourceSection.PREMULTILEAD,
                source: ApplicationSource.PreMultilead
            })
        );
        gtmEventClickSimilarPropertiesCTA(buttonText);
    };

    useEffect(() => {
        startObserver();
    }, []);

    useEffect(() => {
        if (isOnScreen) {
            gtmEventShowSimilarPropertiesCTA(buttonText);
            stopObserver();
        }
    }, [isOnScreen]);

    return (
        <div className={sectionContainerStyle}>
            <Image src={preMultiLeadMapImage} width="178" height="178" alt="preMultiLeadMapImage" className={css({overflow: "visible"})} />
            <div className={textContainerStyle}>
                <Text variant="headline_4" mb={2} className={textStyle}>
                    Zobacz podobne oferty w okolicy
                    {!isMobile && <br />} i porównaj ceny
                </Text>
                <Text variant="body_copy_2" mb={3} className={textStyle}>
                    {`W promieniu 3 km od oglądanej oferty znaleźliśmy ${recommendedProperties.length} ${flatsPlural(recommendedProperties.length)} z Twoimi preferencjami. Niektóre z nich są`}{" "}
                    <strong>
                        w {!isMobile && <br />}
                        korzystniejszej cenie
                    </strong>
                    . Porównaj ceny aby wynegocjować lepsze warunki z deweloperem.
                </Text>
                <Button variant="filled_primary" size="small" className={buttonStyle} onClick={openModal}>
                    {buttonText}
                </Button>
            </div>
            <MultileadModal property={property} />
        </div>
    );
};

const sectionContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 5,
    backgroundColor: "#fff",
    borderRadius: 1,
    padding: 2,
    sm: {
        padding: 3,
        flexDirection: "row"
    }
});

const textContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    sm: {
        alignItems: "flex-start"
    }
});

const buttonStyle = css({
    width: "100%",
    sm: {
        width: "max-content"
    }
});

const textStyle = css({
    textAlign: "center",
    sm: {
        textAlign: "left"
    }
});
import {useEffect} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";
import {pluralize} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {useOnScreenObserver} from "../../atoms/chat_bot/feedback_popup/hooks/use_on_screen_observer";
import {MultileadModal} from "../../lead/multilead/components/multilead_modal/MultileadModal";
import {openMultilead} from "../../lead/multilead/state/multilead_slice";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {useAppDispatch} from "../../store/hooks";
import {gtmEventClickSimilarPropertiesCTA, gtmEventShowSimilarPropertiesCTA} from "../../tracking/google_tag_manager/gtm_event_similar_properties_cta";
import {PREMULTILEAD_TRIGGER} from "../constants/premultilead_trigger";
import {IPropertyDetail} from "../types/IPropertyDetail";
import {IRecommendedProperty} from "../types/IRecommendedProperty";

import preMultiLeadMapImage from "../images/preMultiLeadMapImage.png";

interface IProps {
    property: IPropertyDetail;
    recommendedProperties: IRecommendedProperty[];
}

export const _PropertyDetailPreMultiLeadSection = (props: IProps) => {
    const {property, recommendedProperties} = props;
    const {isMobile} = useUserDevice();
    const dispatch = useAppDispatch();
    const buttonText = InquiryButtonTypeName.SHOW_SIMILAR_OFFERS;
    const flatsPlural = pluralize(["mieszkanie zgodne", "mieszkania zgodne", "mieszkań zgodnych"]);
    const {isOnScreen, startObserver, stopObserver} = useOnScreenObserver(PREMULTILEAD_TRIGGER);

    const openModal = () => {
        dispatch(
            openMultilead({
                mainPropertyId: property.id,
                mainOfferId: property.offer.id,
                mainVendorId: property.offer.vendor.id,
                sourceSection: ApplicationSourceSection.PREMULTILEAD,
                source: ApplicationSource.PreMultilead
            })
        );
        gtmEventClickSimilarPropertiesCTA(buttonText);
    };

    useEffect(() => {
        startObserver();
    }, []);

    useEffect(() => {
        if (isOnScreen) {
            gtmEventShowSimilarPropertiesCTA(buttonText);
            stopObserver();
        }
    }, [isOnScreen]);

    return (
        <div className={sectionContainerStyle}>
            <Image src={preMultiLeadMapImage} width="178" height="178" alt="preMultiLeadMapImage" className={css({overflow: "visible"})} />
            <div className={textContainerStyle}>
                <Text variant="headline_4" mb={2} className={textStyle}>
                    Zobacz podobne oferty w okolicy
                    {!isMobile && <br />} i porównaj ceny
                </Text>
                <Text variant="body_copy_2" mb={3} className={textStyle}>
                    {`W promieniu 3 km od oglądanej oferty znaleźliśmy ${recommendedProperties.length} ${flatsPlural(recommendedProperties.length)} z Twoimi preferencjami. Niektóre z nich są`}{" "}
                    <strong>
                        w {!isMobile && <br />}
                        korzystniejszej cenie
                    </strong>
                    . Porównaj ceny aby wynegocjować lepsze warunki z deweloperem.
                </Text>
                <Button variant="filled_primary" size="small" className={buttonStyle} onClick={openModal}>
                    {buttonText}
                </Button>
            </div>
            <MultileadModal property={property} />
        </div>
    );
};

const sectionContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 5,
    backgroundColor: "#fff",
    borderRadius: 1,
    padding: 2,
    sm: {
        padding: 3,
        flexDirection: "row"
    }
});

const textContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    sm: {
        alignItems: "flex-start"
    }
});

const buttonStyle = css({
    width: "100%",
    sm: {
        width: "max-content"
    }
});

const textStyle = css({
    textAlign: "center",
    sm: {
        textAlign: "left"
    }
});
